import gql from 'graphql-tag';
import { scheduledSessionParticipantEntryFieldsFragment } from '../fragments';

export const overrideScheduledSessionParticipantEntriesMutation = gql`
  mutation OverrideScheduledSessionParticipantEntries($scheduledSessionId: ID!, $override: ScheduledSessionParticipantEntryOverrideInput!) {
    overrideScheduledSessionParticipantEntries(scheduledSessionId: $scheduledSessionId, override: $override) {
      ...AdminScheduledSessionParticipantEntryFields
    }
  }

  ${scheduledSessionParticipantEntryFieldsFragment}
`;